// image-processing-loader
var previousRequest = require("!!../../../../../node_modules/fox-file-loader/index.js!../../../../../node_modules/file-loader/index.js?name=[path][name].[ext]!./favorites.png");
var dir = previousRequest.replace("favorites.png", "")
module.exports = require("!../../../../../node_modules/fox-image-optimize-plugin/router.js")({
	dir: dir,
	base: "favorites.png",
	name: "favorites",
	ext: ".png",
	query: ""
}, previousRequest);


//////////////////
// WEBPACK FOOTER
// ./images/favorites.png
// module id = 1045
// module chunks = 4